/**
 * TORRAS shared carousel navigator — pairs with snippets/torras-carousel-nav.liquid.
 *
 * Auto-inits every [data-t-cnav] element on DOMContentLoaded (and re-scans on
 * shopify:section:load for the Theme Editor). Loaded once from layout/theme.liquid
 * with `defer`; plain vanilla JS, no modules.
 *
 * Contract (attributes on the nav element, all set by the snippet):
 *   data-t-cnav-track — CSS selector of the scroll track, resolved within the enclosing <section>
 *   data-t-cnav-card  — CSS selector of one card inside the track
 *
 * Behavior: dot sync on scroll, dot-jump, prev/next stepping with end-disabled
 * state, dot rebuild when the visible-card count differs from the server-rendered
 * count (cards hidden per-breakpoint get no dot), prefers-reduced-motion.
 */
(function () {
  'use strict';

  function initNav(nav) {
    if (nav.__tCnav) return;
    var root = nav.closest('section') || document;
    var track = root.querySelector(nav.getAttribute('data-t-cnav-track'));
    var dotsWrap = nav.querySelector('[data-t-cnav-dots]');
    if (!track || !dotsWrap) return;
    nav.__tCnav = true;

    var cardSel = nav.getAttribute('data-t-cnav-card');
    var prev = nav.querySelector('[data-t-cnav-prev]');
    var next = nav.querySelector('[data-t-cnav-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0;

    function cards() {
      return Array.prototype.filter.call(track.querySelectorAll(cardSel), function (c) { return c.offsetWidth > 0; });
    }
    function ensureDots() {
      var n = cards().length;
      if (dotsWrap.children.length === n) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 't-cnav-dot';
        b.tabIndex = -1;
        dotsWrap.appendChild(b);
      }
    }
    function nearest() {
      var cs = cards();
      if (!cs.length) return 0;
      var base = cs[0].offsetLeft, sl = track.scrollLeft, min = Infinity, n = 0;
      for (var i = 0; i < cs.length; i++) {
        var d = Math.abs(cs[i].offsetLeft - base - sl);
        if (d < min) { min = d; n = i; }
      }
      return n;
    }
    function render(i) {
      idx = i;
      var ds = dotsWrap.children;
      for (var k = 0; k < ds.length; k++) { ds[k].classList.toggle('on', k === i); }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= ds.length - 1;
    }
    function goTo(i) {
      var cs = cards();
      if (!cs.length) return;
      i = Math.max(0, Math.min(cs.length - 1, i));
      track.scrollTo({ left: Math.max(0, cs[i].offsetLeft - cs[0].offsetLeft), behavior: reduce ? 'auto' : 'smooth' });
      render(i);
    }

    dotsWrap.addEventListener('click', function (e) {
      var d = e.target.closest('.t-cnav-dot');
      if (d) goTo(Array.prototype.indexOf.call(dotsWrap.children, d));
    });
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { render(nearest()); });
    }, { passive: true });
    window.addEventListener('resize', function () { ensureDots(); render(nearest()); }, { passive: true });

    ensureDots();
    render(0);
  }

  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-t-cnav]'), initNav);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
